<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-item :label="$t('label.company')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                disabled
                :trigger-change="true"
                dictCode="sys_depart,depart_name,org_code,org_category='1' and del_flag='0'"
                v-decorator="[
                  'companyCode',
                  { initialValue: initCompanyCode, rules: validatorRules.companyCode.rules },
                ]"
                type="list"
                :placeholder="$t('label.pleaseSelectCompany')"
              />
              <!--<a-input v-decorator="['companyCode']" placeholder="请输入公司编码"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.grower')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                :trigger-change="true"
                v-decorator="['farmerCode', validatorRules.farmerCode]"
                type="list"
                :dict="dictFarmerCode"
                :placeholder="$t('label.pleaseSelectGrower')"
              />
              <!--<a-input v-decorator="['farmerCode']" placeholder="请输入养户编码"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.category')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                :trigger-change="true"
                v-decorator="['breedVarietyCode', validatorRules.breedVarietyCode]"
                type="list"
                @change="handleBreedClass"
                dictCode="sys_category,name,code,pid=(select id from sys_category where code='A01' AND name = '物种分类')"
                :placeholder="$t('label.pleaseSelectCategory')"
              />
              <!-- <a-input v-decorator="['breedVarietyCode']" placeholder="请输入品类编码"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.breedingStrain')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                :trigger-change="true"
                v-decorator="['breedStrainCode', validatorRules.breedStrainCode]"
                type="list"
                :dictCode="dictBreedStrainCode"
                :placeholder="$t('label.pleaseSelectBreed')"
              />
              <!--<a-input v-decorator="['breedStrainCode']" placeholder="请输入品系编码"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.version')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['version', validatorRules.version]" :placeholder="$t('label.pleaseEnterTheVersion')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item v-has="'defaultFlag'" :label="$t('label.defaultVersion')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-radio-group v-decorator="['defaultFlag', { initialValue: 'Y' }]">
                <a-radio value="Y">{{$t('label.yes')}}</a-radio>
                <a-radio value="N">{{$t('label.no')}}</a-radio>
              </a-radio-group>
              <!-- <a-input v-decorator="['defaultFlag']" placeholder="请输入默认版本"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.effectiveDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date
                :placeholder="$t('label.pleaseSelectEffectiveDate')"
                :disabled="postDateDisabled"
                v-decorator="['postDate', { initialValue: initPostDate, rules: validatorRules.postDate.rules }]"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" style="margin-left: 140px">
            <a-button @click="handleTableSelect" type="primary" icon="check">{{$t('button.extractionCompanyDetails')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="$t('tabName.feedingStandards')" :key="refKeys[0]">
        <j-editable-table
          :ref="refKeys[0]"
          :tableName="subTable[0]"
          :loading="efsStdFarmerFeedingDetailTable.loading"
          :columns="efsStdFarmerFeedingDetailTable.columns"
          :dataSource="efsStdFarmerFeedingDetailTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"
          @valueChange="handleValueChange"
        />
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.immunizationStandards')" :key="refKeys[1]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[1]"
          :tableName="subTable[1]"
          :loading="efsStdFarmerImmunityDetailTable.loading"
          :columns="efsStdFarmerImmunityDetailTable.columns"
          :dataSource="efsStdFarmerImmunityDetailTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"
          @valueChange="handleValueChangeNew"
        />
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.medicationStandard')" :key="refKeys[2]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[2]"
          :tableName="subTable[2]"
          :loading="efsStdFarmerMedicationDetailTable.loading"
          :columns="efsStdFarmerMedicationDetailTable.columns"
          :dataSource="efsStdFarmerMedicationDetailTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"
          @valueChange="handleValueChangeDrug"
        />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { getAction } from '@/api/manage'
import { FormTypes, getRefPromise } from '@/utils/JEditableTableUtil'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDate from '@/components/jeecg/JDate'
import { getMaterialInfoByMmCode, getMmListNoPage, ajaxGetDictItems, getCurrentUser } from '@/api/api'
import moment from 'moment'

export default {
  name: 'EfsStdFarmerStandardForm',
  mixins: [JEditableTableMixin],
  components: {
    JFormContainer,
    JDate,
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      validatorRules: {
        companyCode: { rules: [{ required: true, message: this.$t('label.pleaseSelectCompany') }] },
        breedVarietyCode: { rules: [{ required: true, message: this.$t('label.pleaseSelectCategory') }] },
        breedStrainCode: { rules: [{ required: true, message: this.$t('label.pleaseSelectBreed') }] },
        version: { rules: [{ required: true, message: this.$t('label.pleaseEnterTheVersion') }] },
        farmerCode: { rules: [{ required: true, message: this.$t('label.pleaseSelectGrower') }] },
        postDate: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectEffectiveDate') }],
        },
      },
      refKeys: ['efsStdFarmerFeedingDetail', 'efsStdFarmerImmunityDetail', 'efsStdFarmerMedicationDetail'],
      tableKeys: ['efsStdFarmerFeedingDetail', 'efsStdFarmerImmunityDetail', 'efsStdFarmerMedicationDetail'],
      activeKey: 'efsStdFarmerFeedingDetail',
      // efs_std_farmer_feeding_detail
      efsStdFarmerFeedingDetailTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: this.$t('tableHeader.dayAge'),
            // title: '日龄',
            key: 'days',
            type: FormTypes.inputNumber,
            width: '80px',
            disabled: true,
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.weekAge'),
            // title: '周龄',
            key: 'weeks',
            type: FormTypes.inputNumber,
            width: '80px',
            disabled: true,
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.feedNumber'),
            // title: '饲料编号',
            key: 'mmCode',
            type: FormTypes.sel_search,
            disabled: true,
            mmCode: true,
            width: '200px',
            placeholder: this.$t('tip.pleaseSelect') + '${title}',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseSelect') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.feedName'),
            // title: '饲料名称',
            key: 'mmName',
            type: FormTypes.normal,
            disabled: true,
            width: '400px',
          },
          {
            title: this.$t('tableHeader.feedingAmount'),
            // title: '饲喂量/g',
            key: 'feedAmount',
            type: FormTypes.inputNumber,
            disabled: true,
            width: '100px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
        ],
      },
      // efs_std_farmer_immunity_detail
      efsStdFarmerImmunityDetailTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: this.$t('tableHeader.dayAge'),
            // title: '日龄',
            key: 'days',
            type: FormTypes.inputNumber,
            disabled: true,
            width: '80px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.weekAge'),
            // title: '周龄',
            key: 'weeks',
            type: FormTypes.inputNumber,
            width: '80px',
            disabled: true,
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.target'),
            // title: '目标',
            key: 'immunizationTarget',
            type: FormTypes.input,
            disabled: true,
            width: '100px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.vaccineNumber'),
            // title: '疫苗编号',
            key: 'mmCode',
            type: FormTypes.sel_search,
            disabled: true,
            mmCode: true,
            width: '200px',
            placeholder: this.$t('tip.pleaseSelect') + '${title}',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseSelect') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.vaccineName'),
            // title: '疫苗名称',
            key: 'mmName',
            type: FormTypes.normal,
            disabled: true,
            width: '400px',
          },
          {
            title: this.$t('tableHeader.usage'),
            // title: '用法',
            key: 'usefulness',
            type: FormTypes.input,
            disabled: true,
            width: '100px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.quantityUsed'),
            // title: '用量',
            key: 'measure',
            type: FormTypes.input,
            disabled: true,
            width: '100px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.unit'),
            // title: '单位',
            key: 'unit',
            type: FormTypes.input,
            disabled: true,
            width: '100px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
        ],
      },
      // efs_std_farmer_medication_detail
      efsStdFarmerMedicationDetailTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: this.$t('tableHeader.drugNumber'),
            // title: '药品编号',
            key: 'mmCode',
            type: FormTypes.sel_search,
            mmCode: true,
            width: '200px',
            placeholder: this.$t('tip.pleaseSelect') + '${title}',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseSelect') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.drugName'),
            // title: '药品名称',
            key: 'mmName',
            type: FormTypes.normal,
            width: '400px',
          },
        ],
      },
      url: {
        add: '/farmerStandard/efsStdFarmerStandard/add',
        edit: '/farmerStandard/efsStdFarmerStandard/edit',
        queryById: '/farmerStandard/efsStdFarmerStandard/queryById',
        efsStdFarmerFeedingDetail: {
          list: '/farmerStandard/efsStdFarmerStandard/queryEfsStdFarmerFeedingDetailByMainId',
        },
        efsStdFarmerImmunityDetail: {
          list: '/farmerStandard/efsStdFarmerStandard/queryEfsStdFarmerImmunityDetailByMainId',
        },
        efsStdFarmerMedicationDetail: {
          list: '/farmerStandard/efsStdFarmerStandard/queryEfsStdFarmerMedicationDetailByMainId',
        },
        queryMaterials: '/companyStandard/efsStdCompanyStandard/queryMaterials',
        queryCompanyStandard: '/companyStandard/efsStdCompanyStandard/queryCompanyStandard',
      },
      initCompanyCode: null,
      dictFarmerCode: '',
      dictBreedStrainCode: '',
      postDateDisabled: false,
      initPostDate: moment(new Date()).format('YYYY-MM-DD'),
      mainTable: 'efs_std_farmer_standard',
      subTable: ['efs_std_farmer_feeding_detail', 'efs_std_farmer_immunity_detail', 'efs_std_farmer_medication_detail']
    }
  },
  props: {
    //流程表单data
    formData: {
      type: Object,
      default: () => {},
      required: false,
    },
    //表单模式：false流程表单 true普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false,
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    formDisabled() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return true
        }
      }
      return false
    },
  },
  created() {
    //如果是流程中表单，则需要加载流程表单data
    this.showFlowData()
    getCurrentUser().then((res) => {
      if (res.success) {
        this.initCompanyCode = res.result.orgCode
        this.dictFarmerCode =
          "efs_md_farmer,CONCAT(code((comma))((verticalLine))((comma))name),code,company_code like '" +
          res.result.orgCode +
          "*' and del_flag='N'"
      }
    })
  },
  methods: {
    addBefore() {
      this.form.resetFields()
      this.efsStdFarmerFeedingDetailTable.dataSource = []
      this.efsStdFarmerImmunityDetailTable.dataSource = []
      this.efsStdFarmerMedicationDetailTable.dataSource = []
    },
    getAllTable() {
      let values = this.tableKeys.map((key) => getRefPromise(this, key))
      return Promise.all(values)
    },
    /** 调用完edit()方法之后会自动调用此方法 */
    editAfter() {
      let fieldval = pick(
        this.model,
        'code',
        'companyCode',
        'farmerCode',
        'breedVarietyCode',
        'breedStrainCode',
        'version',
        'remarks',
        'approvalStatus',
        'applicant',
        'applyTime',
        'lastApprover',
        'lastApproveTime',
        'buffer1',
        'buffer2',
        'buffer3',
        'buffer4',
        'buffer5',
        'buffer6',
        'buffer7',
        'buffer8',
        'buffer9',
        'buffer10',
        'validFlag',
        'delFlag',
        'createBy',
        'createTime',
        'updateBy',
        'updateTime',
        'sysOrgCode',
        'defaultFlag',
        'postDate'
      )
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
      })
      this.getDrug()
      // 加载子表数据
      if (this.model.id) {
        this.dictBreedStrainCode =
          "sys_category,name,code,pid=(select id from sys_category where code= '" + this.model.breedVarietyCode + "')"
        //this.handleBreedClass(this.model.breedVarietyCode);

        let params = { id: this.model.id }
        this.requestSubTableData(this.url.efsStdFarmerFeedingDetail.list, params, this.efsStdFarmerFeedingDetailTable)
        this.requestSubTableData(this.url.efsStdFarmerImmunityDetail.list, params, this.efsStdFarmerImmunityDetailTable)
        this.requestSubTableData(
          this.url.efsStdFarmerMedicationDetail.list,
          params,
          this.efsStdFarmerMedicationDetailTable
        )
        //饲喂标准饲料传0
        this.handleChooseFeed('0')
        //免疫标准药品传1
        this.handleChooseFeed('1')
        this.postDateDisabled = true
      } else {
        //饲喂标准饲料传0
        this.handleChooseFeed('0')
        /* //用药标准饲料传2
            this.handleChooseFeed("2");*/
        //免疫标准药品传1
        this.handleChooseFeed('1')
        this.dictBreedStrainCode = ''
        this.postDateDisabled = false
      }
    },
    getSubTableSubData(dataSource, tab) {
      // 拿到下边表数据渲染上边form
      let newDataSource = dataSource
      newDataSource.map((item) => {
        item.mmCode = this.emptySelect(item.mmCode)
      })
      tab.dataSource = newDataSource
    },
    /** 整理成formData */
    classifyIntoFormData(allValues) {
      let main = Object.assign(this.model, allValues.formValue)
      return {
        ...main, // 展开
        efsStdFarmerFeedingDetailList: allValues.tablesValue[0].values,
        efsStdFarmerImmunityDetailList: allValues.tablesValue[1].values,
        efsStdFarmerMedicationDetailList: allValues.tablesValue[2].values,
      }
    },
    //渲染流程表单数据
    showFlowData() {
      if (this.formBpm === true) {
        let params = { id: this.formData.dataId }
        getAction(this.url.queryById, params).then((res) => {
          if (res.success) {
            this.edit(res.result)
          }
        })
      }
    },
    validateError(msg) {
      this.$message.error(msg)
    },
    getMaterial() {
      let dictCode =
        "efs_md_material,CONCAT(code((comma))((verticalLine))((comma))name),code, mm_grp_code IN (select code from efs_md_mm_group where category='10' and valid_flag='Y' and del_flag='N')"

      ajaxGetDictItems(dictCode, null).then((res) => {
        if (res.success) {
          let newobj = {}
          let arr = res.result.reduce((preVal, curVal) => {
            newobj[curVal.value] ? '' : (newobj[curVal.value] = preVal.push(curVal))
            return preVal
          }, [])
          let relRes = []
          arr.map((item) => {
            relRes.push({
              // label: item.value,
              label: item.value,
              value: item.value,
              option: item.text,
            })
          })
          this.efsStdCompanyFeedingDetailTable.columns[2].options = relRes
        }
      })
    },
    getImmunity() {
      let dictCode =
        "efs_md_material,CONCAT(code((comma))((verticalLine))((comma))name((comma))((verticalLine))((comma))oem),code, mm_grp_code IN (select code from efs_md_mm_group where category='12' and valid_flag='Y' and del_flag='N')"

      ajaxGetDictItems(dictCode, null).then((res) => {
        if (res.success) {
          let newobj = {}
          let arr = res.result.reduce((preVal, curVal) => {
            newobj[curVal.value] ? '' : (newobj[curVal.value] = preVal.push(curVal))
            return preVal
          }, [])
          let relRes = []
          arr.map((item) => {
            relRes.push({
              // label: item.value,
              label: item.value,
              value: item.value,
              option: item.text,
            })
          })
          this.efsStdCompanyImmunityDetailTable.columns[3].options = relRes
        }
      })
    },

    getDrug() {
      let dictCode =
        "efs_md_material,CONCAT(code((comma))((verticalLine))((comma))name),code, mm_grp_code IN (select code from efs_md_mm_group where category='11' and valid_flag='Y' and del_flag='N') and valid_flag='Y' and del_flag='N' order by code asc"
      ajaxGetDictItems(dictCode, null).then((res) => {
        if (res.success) {
          let newobj = {}
          let arr = res.result.reduce((preVal, curVal) => {
            newobj[curVal.value] ? '' : (newobj[curVal.value] = preVal.push(curVal))
            return preVal
          }, [])
          let relRes = []
          arr.map((item) => {
            relRes.push({
              // label: item.value,
              label: item.value,
              value: item.value,
              option: item.text,
            })
          })
          this.efsStdFarmerMedicationDetailTable.columns[0].options = relRes
        }
      })
      /*if (this.model.id) {*/
      //用药标准饲料传2
      this.handleChooseFeed('2')
      /* }*/
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'code',
          'companyCode',
          'farmerCode',
          'breedVarietyCode',
          'breedStrainCode',
          'version',
          'remarks',
          'approvalStatus',
          'applicant',
          'applyTime',
          'lastApprover',
          'lastApproveTime',
          'buffer1',
          'buffer2',
          'buffer3',
          'buffer4',
          'buffer5',
          'buffer6',
          'buffer7',
          'buffer8',
          'buffer9',
          'buffer10',
          'validFlag',
          'delFlag',
          'createBy',
          'createTime',
          'updateBy',
          'updateTime',
          'sysOrgCode',
          'defaultFlag',
          'postDate'
        )
      )
    },
    handleTableSelect() {
      let companyCode = this.form.getFieldValue('companyCode')
      if (companyCode == '' || companyCode == undefined) {
        this.$message.warning(this.$t('label.pleaseSelectCompany'))
        return
      }
      let breedVarietyCode = this.form.getFieldValue('breedVarietyCode')
      if (breedVarietyCode == '' || breedVarietyCode == undefined) {
        this.$message.warning(this.$t('label.pleaseSelectCategory'))
        return
      }
      let breedStrainCode = this.form.getFieldValue('breedStrainCode')
      if (breedStrainCode == '' || breedStrainCode == undefined) {
        this.$message.warning(this.$t('label.pleaseSelectBreed'))
        return
      }
      getAction(this.url.queryCompanyStandard, {
        companyCode: companyCode,
        breedVarietyCode: breedVarietyCode,
        breedStrainCode: breedStrainCode,
      }).then((res) => {
        if (res.success) {
          this.handleChooseFeed('0')
          this.handleChooseFeed('1')
          this.efsStdFarmerFeedingDetailTable.dataSource = []
          this.efsStdFarmerImmunityDetailTable.dataSource = []
          this.efsStdFarmerFeedingDetailTable.dataSource = res.result.efsStdCompanyFeedingDetailList
          this.efsStdFarmerImmunityDetailTable.dataSource = res.result.efsStdCompanyImmunityDetailList
          this.$refs.efsStdFarmerFeedingDetail.$forceUpdate()
          this.$refs.efsStdFarmerImmunityDetail.$forceUpdate()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleChooseFeed(type) {
      getAction(this.url.queryMaterials, { type: type }).then((res) => {
        if (res.success) {
          let allOptions = res.result || []
          let options = []
          if (allOptions && allOptions.length) {
            if (type == '1') {
              allOptions.map((item) => {
                options.push({
                  label: this.emptySelect(item.code),
                  value: item.code,
                  option: this.emptySelect(item.code + '|' + item.name + '|' + item.oem),
                })
              })
            } else {
              allOptions.map((item) => {
                options.push({
                  label: this.emptySelect(item.code),
                  value: item.code,
                  option: this.emptySelect(item.code + '|' + item.name),
                })
              })
            }
          }
          if (type == '0') {
            this.efsStdFarmerFeedingDetailTable.columns[2].options = options
            this.$refs.efsStdFarmerFeedingDetail.$forceUpdate()
          } else if (type == '1') {
            this.efsStdFarmerImmunityDetailTable.columns[3].options = options
            this.$refs.efsStdFarmerImmunityDetail.$forceUpdate()
          } else {
            this.efsStdFarmerMedicationDetailTable.columns[0].options = options
            this.$refs.efsStdFarmerMedicationDetail.$forceUpdate()
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleValueChange(event) {
      if (event.column.key === 'days') {
        // 计算周龄  日龄/7 按进一法取整
        let weeks = Math.ceil(event.row.days / 7)
        this.$refs.efsStdFarmerFeedingDetail.setValues([
          {
            rowKey: event.row.id,
            values: {
              weeks: weeks,
            },
          },
        ])
        this.$refs.efsStdFarmerFeedingDetail.$forceUpdate()
      }
    },
    handleValueChangeNew(event) {
      if (event.column.key === 'days') {
        // 计算周龄  日龄/7 按进一法取整
        let weeks = Math.ceil(event.row.days / 7)
        this.$refs.efsStdFarmerImmunityDetail.setValues([
          {
            rowKey: event.row.id,
            values: {
              weeks: weeks,
            },
          },
        ])
        this.$refs.efsStdFarmerImmunityDetail.$forceUpdate()
      }
    },
    handleValueChangeDrug(event) {
      if (event.column.dmmNo === true) {
        getMaterialInfoByMmCode({ mmCode: event.row.mmCode }).then((res) => {
          if (res.success) {
            this.$refs.efsStdFarmerMedicationDetail.setValues([
              {
                rowKey: event.row.id,
                values: {
                  mmName: res.result.name,
                },
              },
            ])
            this.$refs.efsStdFarmerMedicationDetail.$forceUpdate()
          }
        })
      } else if (event.column.mmCode === true) {
        getMaterialInfoByMmCode({ mmCode: event.row.mmCode }).then((res) => {
          if (res.success) {
            this.$refs.efsStdFarmerMedicationDetail.setValues([
              {
                rowKey: event.row.id,
                values: {
                  mmName: res.result.name,
                },
              },
            ])
            this.$refs.efsStdFarmerMedicationDetail.$forceUpdate()
          }
        })
      }
    },
    handleBreedClass(value) {
      this.dictBreedStrainCode = "sys_category,name,code,pid=(select id from sys_category where code= '" + value + "')"
      this.model.breedStrainCode = ''
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'breedStrainCode'))
      })
    },
  },
}
</script>

<style scoped>
</style>